import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "brand-marquee py-5" }
const _hoisted_2 = { class: "marquee-track scroll" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]

import { ref, onMounted } from 'vue';
import { useApolloClient } from '@vue/apollo-composable';
import { getBrandMarquee } from "@/utils/graphql";
import { CmsBaseUrl } from "@/utils/functions";


export default /*@__PURE__*/_defineComponent({
  __name: 'BrandMarquee',
  setup(__props) {

const logos = ref<Array<{ src: string; alt: string; link: string }>>([]);
const { resolveClient } = useApolloClient();
const ApolloClient = resolveClient();

onMounted(async () => {
    try {
        const result = await getBrandMarquee(ApolloClient);
        logos.value = result as Array<{ src: string; alt: string; link: string }>;
    } catch (error) {
        console.error("Failed to load brand marquee logos:", error);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...logos.value, ...logos.value], (logo, i) => {
        return (_openBlock(), _createElementBlock("a", {
          key: 'top-' + i,
          href: logo.link,
          class: "marquee-link",
          target: "_blank",
          rel: "noopener"
        }, [
          _createElementVNode("img", {
            src: _unref(CmsBaseUrl)() + logo.src,
            alt: logo.alt,
            class: "marquee-logo",
            width: "250",
            height: "50"
          }, null, 8, _hoisted_4)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})